import imageCompression from 'browser-image-compression';

interface IOptions {
  maxSizeMB: number,
  maxWidthOrHeight: number,
  useWebWorker: boolean,
}

const compressImage = async (image: File): Promise<File> => {
  try {
    const options: IOptions = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    return await imageCompression(image, options);
  } catch (error) {
    throw new Error(error);
  }
};

export default compressImage;
